import React, { useState } from 'react';
import { Column } from 'rbx';
import styled from 'styled-components';

// import { isNull } from 'lodash';

import { Select } from '../../../../components/elements';
import DiscountValueInput from './DiscountValueInput';
import { onAddItems } from '../helpers';

const IconStyled = styled.i`
  margin-right: 10px;
`;

const Container = styled(Column.Group)`
  border-bottom: 1px solid #b0b0b0;
  background-color: #e2e2e2;
`;

const RemoveWrapper = styled(Column)`
  cursor: pointer;
  color: #ee2a7b;
  padding-top: 18px;
`;

const CategoryRow = ({
  categoryName,
  initialDiscountType,
  initialDiscountValue,
  links,
  setLinks,
  onRemoveItem,
  children,
  setFieldValue,
}) => {
  const [isActive, setIsActive] = useState(true);

  const discountTypeOptions = [
    { value: 'PERCENTAGE', label: '% rate' },
    { value: 'PRICE', label: 'flat rate' },
  ];

  const [discountType, setDiscountType] = useState(
    discountTypeOptions.find(ele => ele.value === initialDiscountType),
  );
  const [discountValue, setDiscountValue] = useState(initialDiscountValue);

  React.useEffect(() => {
    const temp = [];

    links.forEach(ele => {
      if (ele.menu_section_name === categoryName) {
        temp.push(onAddItems(ele, discountType.value, discountValue));
      } else {
        temp.push(ele);
      }
    });

    setLinks(temp);
  }, [discountType?.value, discountValue]);

  return (
    <>
      <Container>
        <Column
          size={2}
          style={{ marginTop: '10px', fontSize: '12px', fontWeight: 700 }}
        >
          <div onClick={() => setIsActive(!isActive)}>
            {isActive ? (
              <IconStyled className="fas fa-chevron-down" />
            ) : (
              <IconStyled className="fas fa-chevron-right" />
            )}
          </div>
        </Column>
        <Column
          size={2}
          style={{ marginTop: '10px', fontSize: '12px', fontWeight: 700 }}
        >
          {categoryName}
        </Column>
        <Column size={10} style={{ fontSize: '13px' }}>
          <Column.Group>
            <Column size={2} style={{ paddingTop: '8px' }}>
              <Select
                value={discountType}
                options={discountTypeOptions}
                onChange={value => {
                  setFieldValue('linksForCategoryIsDirty', true);
                  setDiscountType(value);
                }}
              />
            </Column>
            <Column size={2}>
              <DiscountValueInput
                value={discountValue}
                discountType={discountType?.value}
                price=""
                onChange={e => {
                  setFieldValue('linksForCategoryIsDirty', true);
                  setDiscountValue(e.target.value);
                }}
              />
            </Column>
            <Column size={2} />
            <Column size={2} />
            <RemoveWrapper
              onClick={onRemoveItem}
              size={2}
              style={{ fontSize: '12px' }}
            >
              Remove
            </RemoveWrapper>
          </Column.Group>
        </Column>
      </Container>
      {isActive && children}
    </>
  );
};

export default CategoryRow;
